import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Container from "./Container";
import List from "./List";
import Item from "./Item";
import Copyright from "./Copyright";
var propTypes = {
  list: PropTypes.arrayOf(PropTypes.node),
  copyrightYear: PropTypes.number
};
var defaultProps = {
  list: []
};
export function AppFooter(_ref) {
  var list = _ref.list,
      copyrightYear = _ref.copyrightYear,
      props = _objectWithoutProperties(_ref, ["list", "copyrightYear"]);

  return React.createElement(Container, props, React.createElement("nav", null, React.createElement(List, null, list.map(function (item, i) {
    return React.createElement(Item, {
      key: item.key || i
    }, item);
  }))), React.createElement("div", null, copyrightYear && React.createElement(Copyright, null, "\xA9 ", copyrightYear, " Spotify AB")));
}
AppFooter.propTypes = propTypes;
AppFooter.defaultProps = defaultProps;
export default AppFooter;